import type { CartLine, Menu } from '../../shared/menu';
import { findDish } from '../../shared/menu';

// After a combined re-parse from "Add page", Gemini mints fresh dishIds (it
// numbers dishes globally per parse). To preserve in-progress cart lines we
// reconcile by exact `nameOriginal` match — the verbatim source-language
// menu text, which is stable across parses except in pathological cases.
//
// Returns the rewritten lines (with new dishId/categoryId) and the display
// names of any lines that couldn't be matched, so the caller can surface a
// "couldn't carry over" toast.
export function migrateCartToNewMenu(
  cartLines: CartLine[],
  oldMenu: Menu,
  newMenu: Menu,
): { migrated: CartLine[]; orphanedNames: string[] } {
  const lookup = new Map<string, { dishId: string; categoryId: string }>();
  for (const cat of newMenu.categories) {
    for (const dish of cat.dishes) {
      lookup.set(dish.nameOriginal, { dishId: dish.id, categoryId: cat.id });
    }
  }

  const migrated: CartLine[] = [];
  const orphanedNames: string[] = [];
  for (const line of cartLines) {
    const oldDish = findDish(oldMenu, line.dishId)?.dish;
    if (!oldDish) continue;
    const found = lookup.get(oldDish.nameOriginal);
    if (!found) {
      orphanedNames.push(oldDish.nameTranslated || oldDish.nameOriginal);
      continue;
    }
    migrated.push({ ...line, dishId: found.dishId, categoryId: found.categoryId });
  }
  return { migrated, orphanedNames };
}
